






















import { Component } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerEntity } from "@/models/partnerEntity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FeatureModule } from "@/store/modules/feature.store";
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import { mixins } from "vue-class-component";
import CanMixin from "@/mixins/CanMixin.vue";

@Component
export default class ThePartnerList extends mixins(CanMixin) {
  loading = false;
  selected = 1;
  expanded = true;

  set partner(partner: PartnerEntity) {
    PartnerModule.setPartner(partner);
    this.$router.push({ name: "PartnerDashboard", params: { partnerId: partner._id } });
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partners() {
    return PartnerModule.partners;
  }

  get name() {
    return PartnerModule.partner.companyName;
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  get items() {
    const items: IMenuListItem[] = [
      {
        icon: "mdi-view-dashboard-outline",
        text: "navigation.ThePartnerList.overview",
        link: `/partners/${this.partnerId}/home`
      },
      {
        icon: "mdi-car-outline",
        text: "navigation.ThePartnerList.report",
        link: `/partners/${this.partnerId}/report`
      },
      {
        icon: "mdi-email-multiple-outline",
        text: "navigation.ThePartnerList.form",
        link: `/partners/${this.partnerId}/form`
      }
    ];

    if (FeatureModule.isTemplateEnabled) {
      items.push({
        icon: "mdi-book",
        text: "Templates",
        link: `/partner/${this.partnerId}/template`,
        permission: {
          resource: ResourceEnum.TEMPLATE,
          action: ActionEnum.READ
        }
      });
    }

    return items;
  }

  get settingItems() {
    const items: IMenuListItem[] = [];

    if (FeatureModule.isPartnerManagerEnabled) {
      items.push({
        icon: "mdi-file-cog-outline",
        text: "components.partner.PartnerManagerList.title",
        link: `/partners/${this.partnerId}/manage`,
        permission: {
          resource: ResourceEnum.PARTNER,
          action: ActionEnum.READ
        }
      });
    }

    items.push({
      icon: "mdi-swap-vertical-bold",
      text: "navigation.ThePartnerList.setting.operations",
      link: `/partners/${this.partnerId}/operation`
    });

    return items;
  }
}
